/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { layersConfig } from './layersConfig';
import { addWidget, createFormIdentify, defineLayersAndLayersFilterForIdentify, getContractExtent, getParamsForDisplayLayerButton, getParamsForIdentify, loadingDom, searchContract, ZoomButtonDom } from '../../utils/helpers/map/mapHelper';
import { displayLayerButton } from './component/displayLayer';
import { isEmptyLayer, showHideLayers } from '../../utils/helpers/module/moduleComponentHelper';
import Extend from '../common/Icon/extend.svg';
import { HttpArcgis } from '../../utils/http';
import { deverssementPopup, getDeverssementInfoFirstPage, getDeverssementInfoSecondPage } from '../../utils/helpers/map/ecpPopupHelper';
import { getContentPopup, getIndicatorForPopup } from '../../utils/helpers/map/popupHelper';
import { LocalStorage } from '../../utils/localStorage';
import ReactDOMServer from 'react-dom/server';
import Extent from '@arcgis/core/geometry/Extent';
import { markerSymbol } from './mapCss';
import { app_placeholder } from '../../env.placeholders';

interface ArcgisMapProps {
  getLayers(pLayers: any): void;
  getExtent(pExtent: any): void;
  module: string;
  option?: any;
  bcRenderer: any;
  filters: {
    query: string;
    spatialFilter: any;
  };
  zoomToPoint?: { x: number; y: number };
}

const ArcgisMap: React.FC<ArcgisMapProps> = ({ filters, getExtent, getLayers, module, option, bcRenderer, zoomToPoint }) => {
  const viewDivRef = useRef<HTMLDivElement>(null);
  const mapImageLayerRef = useRef<any>(null);
  const viewRef = useRef<any>(null);
  const [displayLayer, setDisplayLayer] = useState(false);
  const [mapView, setMapView] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const moduleButtons = ['pr', 'ecp', 'pluie', 'do', 'h2s'];

  // Helper for zoom
  const zoomTo = (pResult: any, view: any) => {
    if (pResult !== null && pResult.extent !== null) {
      const extent = new Extent({
        xmin: pResult.extent?.xmin,
        ymin: pResult.extent?.ymin,
        xmax: pResult.extent?.xmax,
        ymax: pResult.extent?.ymax,
        spatialReference: pResult.extent?.spatialReference?.wkid,
      });
      view.goTo(extent);
    } else {
      console.log('error');
    }
  };

  // Initialisation de la carte et de la couche UNE SEULE FOIS
  useEffect(() => {
    let isMounted = true;
    Promise.all([
      import("@arcgis/core/Map"),
      import("@arcgis/core/views/MapView"),
      import("@arcgis/core/layers/MapImageLayer"),
      import("@arcgis/core/widgets/Popup"),
      import("@arcgis/core/core/reactiveUtils"),
      import("@arcgis/core/config"),
    ]).then(([MapModule, MapViewModule, MapImageLayerModule, PopupModule, reactiveUtilsModule, configModule]) => {
      if (!isMounted) return;

      // Import des modules nécessaires
      const Map = MapModule.default;
      const MapView = MapViewModule.default;
      const Popup = PopupModule.default;
      const MapImageLayer = MapImageLayerModule.default;
      const reactiveUtils = reactiveUtilsModule;
      const config = configModule.default;

      mapImageLayerRef.current = new MapImageLayer({
        url: app_placeholder.VITE_APP_ARCGIS_LAYERS,
        sublayers: layersConfig,
      });
      const map = new Map({
        basemap: "topo-vector",
        layers: [mapImageLayerRef.current],
      });
      const view = new MapView({
        container: viewDivRef.current as HTMLDivElement,
        map,
        popup: new Popup({
          dockOptions: {
            buttonEnabled: false,
          },
        })
      });
      viewRef.current = view;
      view.ui.remove(['attribution']);

        view.when(() => {
        setMapView(view);
        console.log('Map and view are ready');
        // Code à exécuter quand la vue est prête
        config.request.maxUrlLength = 1800;
        
        // add widgets on map
        addWidget(view, 'loaderDiv', 'bottom-left', 1);
        addWidget(view, 'zoomButtonDiv', 'top-right', 1);
        moduleButtons.forEach((module) => {
          const paramsForDisplayLayerButtons = getParamsForDisplayLayerButton(module);
        
          paramsForDisplayLayerButtons.forEach((paramsForDisplayLayerButton) => {
            displayLayerButton(
              paramsForDisplayLayerButton.icon,
              `displayLayerButton_${module}_${paramsForDisplayLayerButton.index}`,
              paramsForDisplayLayerButton.infoBulle!,
              setDisplayLayer,
              paramsForDisplayLayerButton.layers!,
              view,
              {
                position: 'top-leading',
                index: paramsForDisplayLayerButton.index,
              },
            );
          });
        });

        // set assets for arcgislayer method in fitlerform component
        getLayers && getLayers(mapImageLayerRef.current);

        // Display the loading indicator when the view is updating
        reactiveUtils.when(
          () => view.updating,
          () => {
            setLoading(true);
            view.popup?.close();
          }
        );

        // Hide the loading indicator when the view stops updating
        reactiveUtils.when(
          () => !view.updating,
          () => {
            setLoading(false);
          }
        );

        // for hydro module
        reactiveUtils.watch(
          () => view.stationary,
          (stationary) => {
            if (stationary) {
              getExtent && getExtent(view.extent);
            }
          }
        );

        // when you click on map
        view.on('click', async (event) => {
          const type = LocalStorage.type.get();
          view.graphics.removeAll();
          // define layer id to identify
          let layerId: number[] = defineLayersAndLayersFilterForIdentify(
            view.scale,
            type!,
            window.sessionStorage.getItem('location')!
          );            
          // find sublayer to get its definition expression
          let params = getParamsForIdentify(
            (view.map?.allLayers.getItemAt(2) as __esri.MapImageLayer).allSublayers.toArray(),
            layerId
          );
          const layersId = encodeURIComponent(
            type !== 'pluie'
              ? `visible:${params.layers}`
              : `visible:${layerId.join()}`
          );
          const defExp = encodeURIComponent(params.definitionExpression);
          
          // form
          const formBodyToSend = createFormIdentify(
            event.mapPoint,
            layersId,
            defExp,
            view
          );
  
          try {
            const response = await HttpArcgis.post(
              `${app_placeholder.VITE_APP_ARCGIS_SERVER}?path=/identify`,
              JSON.stringify(formBodyToSend)
            );
        
            const results = response?.data?.results;

            // Configure the popup
            view.popup && (view.popup.visibleElements = {
              closeButton: false,
              heading: false,
              actionBar: LocalStorage.type.get() === 'ecp' ? true : false,
              collapseButton: false,
              featureNavigation: true,
              featureListLayerTitle: false,
            });
            
            if (results && results.length > 0) {
              const features = (await Promise.all(results.map(async (feature) => {
                if (type === 'ecp') {
                  // Configuration de la popup pour le type "ecp"
                  feature.popupTemplate = {
                    title: `${feature.attributes['Code']}` || `${feature.attributes['Name']}` || 'NR',
                    content: await deverssementPopup,
                    actions: [
                      {
                        title: 'Page 1',
                        id: 'ecp_popup_p1',
                        icon: 'number-circle-1-f',
                        type: 'button'
                      },
                      {
                        title: 'Page 2',
                        id: 'ecp_popup_p2',
                        icon: 'number-circle-2',
                        type: 'button'
                      }
                    ],
                  };
                  
                } else {
                  // Configuration des autres types de popups
                  const indicator = getIndicatorForPopup(type!, feature);
                  if (indicator) {
                    feature.popupTemplate = {
                      content: await getContentPopup(indicator, feature.layerName),
                      title: `${feature.attributes['Code']}` || `${feature.attributes['Name']}` || 'NR',
                    };
                  } else {
                    return null;
                  }
                }
                return feature;
              }))).filter((feature) => feature !== null); // Filtrer les résultats nulls
                if (features.length > 0) {
                  view.popup?.open({
                    features,
                    location: event.mapPoint,
                  });
                }
            } else {
              console.warn('Aucun résultat trouvé pour cette localisation.');
            }
          } catch (error) {
            console.error('Erreur lors de la requête :', error);
          }
        });

        // manage buttons in popup
        view.popup?.on('trigger-action', async (event) => {
          let attributes = view.popup?.selectedFeature?.attributes;
          // loader in popup
          let content = document.createElement('div');
          const loaderHTML = ReactDOMServer.renderToString(
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
              <div
                style={{
                  width: '34px',
                  height: '34px',
                  border: '5px solid #FFF',
                  borderBottomColor: '#243977',
                  borderRadius: '50%',
                  display: 'inline-block',
                  boxSizing: 'border-box',
                  animation: 'rotation 1s linear infinite',
                }}
              ></div>
              <style>
                {`
                  @keyframes rotation {
                    0% {
                      transform: rotate(0deg);
                    }
                    100% {
                      transform: rotate(360deg);
                    }
                  }
                `}
              </style>
            </div>
          );
          content.innerHTML = loaderHTML;
          view.popup!.content = content;
  
          // prepare the content of the popup
          let newContent;
          if (event.action.id === 'ecp_popup_p1') {
            newContent = await getDeverssementInfoFirstPage(attributes, content);
          } else if (event.action.id === 'ecp_popup_p2') {
            newContent = await getDeverssementInfoSecondPage(attributes, content);
          }

          // update content of popup
          view.popup!.content = newContent;

          // update css' buttons by using querySelector and CSS
          const currentPage = event.action.id?.substring(event.action.id.length - 1, event.action.id.length);          
          // Attendre que le DOM soit mis à jour
          setTimeout(() => {
            const actionIds = ['ecp_popup_p1', 'ecp_popup_p2'];
            actionIds.forEach((actionId, index) => {
              const button = document.querySelector(`calcite-action[data-action-id="${actionId}"]`) as HTMLElement;
              if (button) {
                const iconValue = currentPage === `${index + 1}` ? `number-circle-${index + 1}-f` : `number-circle-${index + 1}`;
                button.setAttribute('icon', iconValue);
              }
            });
          }, 200);
        });
      });
    });

    return () => { isMounted = false; };
  }, []);

  const arcgisLayer = (query: string, spatialFilter: any) => {
    // create defExp
    let newDef;
    if (isEmptyLayer(spatialFilter) === true) {
      newDef = query;
    } else {
      newDef = '1=0';
    }

    // update visibility for layers on map
    showHideLayers(
      newDef,
      module!,
      mapImageLayerRef.current,
      bcRenderer!,
      spatialFilter,
      option!,
    );
    // to refresh the map view
    mapView.goTo(mapView.extent);
    mapView.graphics.removeAll();
  };

  // manage filters to update map
  useEffect(() => {
    if(mapView === null) return;

    mapView && arcgisLayer(filters?.query || '', filters?.spatialFilter || null);
  }, [filters]);

  // manage display of layer button
  useEffect(() => {
    if (mapView && module) {
      moduleButtons.forEach((moduleName) => {
        const paramsForDisplayLayerButtons = getParamsForDisplayLayerButton(moduleName);
  
        paramsForDisplayLayerButtons.forEach((layer) => {
          const btnId = `displayLayerButton_${moduleName}_${layer.index}`;
          const btn = mapView.ui.find(btnId);
  
          if (btn) {
            btn.style.display = moduleName === module ? 'flex' : 'none';
          }
        });
      });
    }
  }, [mapView, module]);

  useEffect(() => {
    if(mapView === null) return;

    searchContract(
      window.sessionStorage.getItem('contractCode'),
      null,
      null,
      mapView
    ).then(() => {
      let sessionStorageExtent =
        JSON.parse(window.sessionStorage.getItem('contractExtent')!) ||
        '';
      if (sessionStorageExtent !== '') {
        zoomTo(
          JSON.parse(window.sessionStorage.getItem('contractExtent')!),
          mapView
        );
      } else {
        getContractExtent(
          window.sessionStorage.getItem('contractCode')!
        ).then((extent) => {
          zoomTo(extent, mapView);
        });
      }
      // close popup already opened on map
      mapView.popup?.close();
      mapView.graphics.removeAll();
    });
  }, [module, option, mapView]);

  // Gestion du zoom via props (React pattern)
  useEffect(() => {
    if (mapView === null || !zoomToPoint) return;

    // Import dynamique des modules ArcGIS nécessaires
    Promise.all([
      import('@arcgis/core/geometry/Point'),
      import("@arcgis/core/Graphic"),
    ]).then(([PointModule, GraphicModule]) => {
      const Point = PointModule.default;
      const Graphic = GraphicModule.default;

      // Zoom vers le point
      mapView.goTo({
        center: [zoomToPoint.x, zoomToPoint.y],
        zoom: 16,
      });

      // Créer un point graphique
      const point = new Point({
        longitude: zoomToPoint.x,
        latitude: zoomToPoint.y,
      });

      // Créer un graphique avec le symbole
      const pointGraphic = new Graphic({
        geometry: point,
        symbol: markerSymbol,
      });

      // Ajouter le graphique à la vue
      mapView.graphics.removeAll();
      mapView.graphics.add(pointGraphic);
    });
  }, [zoomToPoint]);

  return (
    <>
      <div style={{ width: "100%", height: "98vh" }}>
        <div ref={viewDivRef} style={{ width: "100%", height: "100%" }} />
        {/*Widgets on map*/}
        <div style={{ display: mapView === null ? 'none' : 'flex' }}>{ZoomButtonDom(Extend)}</div>
        {loadingDom(loading)}
      </div>
    </>
  );
};

export default ArcgisMap;